import React from 'react'
import _ from '/home/ps/root'
import './index.css'
import { connect } from 'react-redux'
import View from '../../view'
// import {
//   masterPropType,
//   masterStateToProp,
//   masterDispatchToProp,
// } from '../../../type'
export const ID = 'mastersearch'
export class MasterSearch extends View {
  static ID = ID
  onClick = e => {
    console.log('Search.onClick', this.props)
  }
  render = () => {
    const p = {id:ID, onClick:this.onClick}
    return (
      <div {...p}>
        {ID}
        Master Search
      </div>
    )
  }
}
// Search.propTypes = masterPropType;
export default connect(
  // masterStateToProp,
  // masterDispatchToProp
)(MasterSearch)
